export const SPEEDOMETER_ARC_WIDTH = 4;
export const SPEEDOMETER_START_ANGLE = (-3 * Math.PI) / 4;
export const SPEEDOMETER_END_ANGLE = (3 * Math.PI) / 4;
export const SPEEDOMETER_PAD_ANGLE = 0.06;
export const SPEEDOMETER_SVG_TEXT_SIZE = 14;
export const SPEEDOMETER_SVG_TEXT_OFFSET = SPEEDOMETER_SVG_TEXT_SIZE / 2 + 4;
export const SPEEDOMETER_ICON_SIZE = 26;
